<template>
  <div>
    <div class="cardContainer" v-if="listType=='Card'">
      <tournament-card v-for="(tournament, index) in tournaments" :key="index" :tournament="tournament"></tournament-card>
    </div>

    <div v-if="listType=='Table' && tournaments.length > 0" class="flexrow">
      <div class="result-table">
        <div class="result-header right" v-if="topX <= tournaments.length && topX != -1"> {{ $t('tournaments.found') }} ({{ topX }} {{ $t('persons.outOf') }} {{ tournaments.length }})</div>
        <div class="result-header right" v-if="topX > tournaments.length">{{ $t('tournaments.found') }} ({{tournaments.length}})</div>
        <div class="result-header" v-if="topX == -1"><h2>toernooien</h2></div>
        <div v-for="(tournament, index) in topTournaments" :key="index" :tournament="tournament" class="result-line">
          <router-link :to="/tournaments/ + tournament.tournamentId" class="link">{{tournament.name}}</router-link>
          <div class="pushright">{{ showDate(tournament.startDate) }} {{ $t('tournament.until') }} {{ showDate(tournament.endDate) }}</div>
        </div>
      </div>
      <img :src="tournamentIcon" alt="tournaments" class="logo-display-small" />
    </div>
  </div>
</template>
<script>

import moment from 'moment';
import TournamentCard from "@/components/tournaments/TournamentCard";

export default {
  name: 'TournamentsList',
  components: {TournamentCard},
  props: {
    tournaments: Array,
    listType: String,
    topX: -1
  },
  data() {
    return {
      tournamentIcon: require('../../assets/img/CA_Tournament_black.png'),
    }
  },
  computed: {
    topTournaments: function() {
      if (this.tournaments.length > this.topX) {
        return this.tournaments.slice(0, this.topX);
      } else 
        return this.tournaments;
    }
  },
  methods: {
    showDate: function(sDate) {
      moment.locale(this.$i18n.locale);
      return moment(sDate).format("DD MMM yyyy");
    }
  }
}
</script>

<style scoped>

.floatRight {
  float: right;
}
.link:hover {
  font-weight: bold;
}



</style>

